import { render, staticRenderFns } from "./vue-ueditor-wrap.vue?vue&type=template&id=c88ece82&"
import script from "./vue-ueditor-wrap.vue?vue&type=script&lang=js&"
export * from "./vue-ueditor-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vue-ueditor-wrap.vue"
export default component.exports